module.exports = __webpack_public_path__ + "img/home-illustration.b588c9dc.png";